import styled from 'styled-components'

import { s } from '../../styles'

export const { InfoWarning, InfoWarningLabel, InfoWarningContent } = s

export const Inner = styled.div`
  padding: 34px 32px 32px 32px;
`
